<template>

    <div class="container">

        <app-head title="Brands" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Brands') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.brands.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
                <select-input label="Status" v-model="form.status">
                    <option :value="null">{{ __('Veröffentlicht') }}</option>
                    <option value="trashed">{{ __('Papierkorb') }}</option>
                </select-input>
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="brands.meta" />
        </div>

        <div class="card">
            <data-table :items="brands.data"
                        :links="brands.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="brand in brands.data" :key="brand.id">
                    <td>
                        {{ brand.id }}
                    </td>
                    <td>
                        <div v-if="brand.deleted_at">
                            {{ brand.name }}
                        </div>
                        <inertia-link class="" :href="route('admin.brands.edit', brand)" v-else>
                            {{ brand.name }}
                        </inertia-link>
                    </td>
                    <td>
                        <inertia-link class="" :href="route('admin.products.index', {brand_id: brand.id})">
                            {{ brand.number_products || 0 | localizeNumber }}
                        </inertia-link>
                    </td>
                    <td>
                        {{ brand.description || '-' | truncateWords }}
                    </td>
                    <td class="text-end">
                        <template v-if="brand.deleted_at">
                            <button type="button" class="btn btn-outline-success" @click="restore(brand)">
                                {{ __('Restore') }}
                            </button>
                            <button type="button" class="btn btn-outline-danger" @click="destroyPermanently(brand)">
                                {{ __('Destroy permanently') }}
                            </button>
                        </template>
                        <template v-else>
                            <i class="bi bi-chevron-right"></i>
                        </template>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import Results from '@/shared/Admin/Results';


    export default {
        props: {
            filters: Object,
            brands: Object,
        },
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    name: {label: 'Name', sortable: 'name'},
                    number_products: {label: 'Products'},
                    description: {label: 'Description'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.brands.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
            destroyPermanently(brand) {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.brands.destroy-permanently', brand.id));
                }
            },
            restore(brand) {
                this.$inertia.get(this.route('admin.brands.restore', brand.id));
            },
        },
    }
</script>